import { atom } from "jotai";

export const streamedZslAtom = atom<any>({});
streamedZslAtom.debugLabel = "streamedZslAtom";
